
export default {
    state: {
        company: JSON.parse(localStorage.getItem("company")) || {},
        defaultComp: localStorage.getItem("defaultComp"),
        refreshCompany: false,
        showAddCompany: false
    },
    getters: {
        companyName: (state) => state.company.name,
        companyId: (state) => state.company.companyId || state.defaultComp,
        companyType: (state) => state.company.companyType,
        isAdmin: (state) => state.company.isAdmin,
        refreshCompany: (state) => state.refreshCompany,
        showAddCompany: (state) => state.showAddCompany
    },
    mutations: {
        updateCompany (state, company) {
            company = company || {};
            let storyCompany = {
                name: company.name,
                companyId: company._id,
                companyType: company.company_type,
                isAdmin: company.__isAdmin__
            };

            state.company = storyCompany;
            localStorage.setItem("company", JSON.stringify(storyCompany));
        },
        updateDefaultComp (state, defaultComp) {
            state.defaultComp = defaultComp;
            if (defaultComp) {
                localStorage.setItem("defaultComp", defaultComp);
            } else {
                localStorage.removeItem("defaultComp");
            }
        },
        // 是否重新调company接口
        updateRefreshCompany (state, flag) {
            state.refreshCompany = flag;
        },
        updateCompanyName (stat, name) {
            stat.company.name = name;
            localStorage.setItem("company", JSON.stringify(stat.company));
        },
        updateShowAddCompany (state, flag) {
            state.showAddCompany = flag;
        }
    },
    actions: {
        setCompany (state, company) {
            state.commit("updateCompany", company);
        }
    }
};



// WEBPACK FOOTER //
// ./src/store/modules/company.js